export const ROUTES = {
    LANDING: '/',
    SIGN_UP: '/signup',
    SIGN_IN: '/signin',
    HOME: '/home',
    ACCOUNT: '/account',
    ADMIN: '/admin',
    PASSWORD_FORGET: '/pw-forget',
    PRIVACY_POLICY: '/privacypolicy',
    TERMS_CONDITIONS: '/termsandconditions'
}